var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.preloading)?_c('div',[_vm._m(0)]):_c('div',{staticClass:"box"},[_c('TabRapportCommande')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center preloading"},[_c('div',{staticClass:"loader-xl"})])
}]

export { render, staticRenderFns }